import type { JSX } from "react";
import { Spinner } from "@fluentui/react-components";

export interface FluentSpinnerProps {
  label?: string;
  size?: "tiny" | "extra-small" | "small" | "medium" | "large" | "extra-large" | "huge";
}

export function FluentSpinner({ label, size = "small" }: FluentSpinnerProps): JSX.Element {
  return <Spinner size={size} label={label} />;
}
